import { actionTypes as FirebaseActions } from 'react-redux-firebase';

import { DEFAULT_CREATE_SEND_CUSTOM_MESSAGE_STATE } from '../../../constants/createSendCustomMessage';
import { ICreateSendCustomMessageState } from '../../../types/createSendCustomMessage';
import * as AuthActions from '../../actions/auth';
import * as CustomMessageActions from '../actions/customMessage';

export const initialState: ICreateSendCustomMessageState = DEFAULT_CREATE_SEND_CUSTOM_MESSAGE_STATE;

const reducer = (state: ICreateSendCustomMessageState = initialState, action: any): ICreateSendCustomMessageState => {
  switch (action.type) {
    case AuthActions.ADMIN_ROLE_CHANGED:
    case AuthActions.CHANGE_ORGANIZATION_SUCCESS:
    case FirebaseActions.LOGOUT:
    case CustomMessageActions.RESET_CS_CUSTOM_MESSAGE: {
      return initialState;
    }
    case CustomMessageActions.PATCH_CS_CUSTOM_MESSAGE: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};

export default reducer;
